import { render, staticRenderFns } from "./SowingMethodsCreateEdit.vue?vue&type=template&id=55006759"
import script from "./SowingMethodsCreateEdit.vue?vue&type=script&lang=js"
export * from "./SowingMethodsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports